import script from "./CompanySearch.vue?vue&type=script&setup=true&lang=ts"
export * from "./CompanySearch.vue?vue&type=script&setup=true&lang=ts"

import "./CompanySearch.vue?vue&type=style&index=0&id=eeac3bf2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-eeac3bf2"]])

export default __exports__